import { Container, Spinner } from '@cleartrip/ct-design-components'

const EmiOptionsLoader = () => {
  return (
    <Container className='flex-1 flex flex-middle flex-center'>
      <Spinner borderColor='#3367cc' height='35px' width='35px' />
    </Container>
  )
}

export default EmiOptionsLoader
